export function getSf009AddedByDisplay(record, appUsers = []) {
  const savedName = String(record?.createdByName || "").trim();
  if (savedName) return savedName;

  const uid = record?.createdBy;
  if (uid == null || uid === "") return "—";

  const u = appUsers.find((x) => String(x._id) === String(uid));
  if (u) {
    const full = [u.firstName, u.lastName].filter(Boolean).join(" ").trim();
    return full || u.email || "—";
  }

  return "—";
}
